module.exports = __webpack_public_path__ + "static/media/figure-9.408cc0db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-9.jpg
// module id = 1219
// module chunks = 0